import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,

    integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),

        Sentry.replayCanvasIntegration(),
        Sentry.browserProfilingIntegration(),
    ],

    replaysSessionSampleRate: import.meta.env
        .VITE_SENTRY_JS_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: import.meta.env
        .VITE_SENTRY_JS_REPLAYS_ON_ERROR_SAMPLE_RATE,

    tracesSampleRate: import.meta.env.VITE_SENTRY_JS_TRACES_SAMPLE_RATE,
    tracePropagationTargets: [
        import.meta.env.VITE_INTERNET_URL,
        import.meta.env.VITE_INTRANET_URL,
    ],

    ignoreErrors: ["Non-Error promise rejection captured"],
});
